"use strict";

function objectAssignPolyfill() {
  "function" != typeof Object.assign && (Object.assign = function (e, t) {
    var n = arguments;
    if (null == e) throw new TypeError("Cannot convert undefined or null to object");

    for (var i = Object(e), o = 1; o < arguments.length; o++) {
      var r = n[o];
      if (null != r) for (var s in r) {
        Object.prototype.hasOwnProperty.call(r, s) && (i[s] = r[s]);
      }
    }

    return i;
  });
}

function objectKeysPolyfill() {
  var e, t, n, i;
  Object.keys || (Object.keys = (e = Object.prototype.hasOwnProperty, t = !{
    toString: null
  }.propertyIsEnumerable("toString"), i = (n = ["toString", "toLocaleString", "valueOf", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "constructor"]).length, function (o) {
    if ("function" != typeof o && ("object" != typeof o || null === o)) throw new TypeError("Object.keys called on non-object");
    var r,
        s,
        a = [];

    for (r in o) {
      e.call(o, r) && a.push(r);
    }

    if (t) for (s = 0; s < i; s++) {
      e.call(o, n[s]) && a.push(n[s]);
    }
    return a;
  }));
}

function __rest(e, t) {
  var n = {};

  for (var i in e) {
    Object.prototype.hasOwnProperty.call(e, i) && t.indexOf(i) < 0 && (n[i] = e[i]);
  }

  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var o = 0;

    for (i = Object.getOwnPropertySymbols(e); o < i.length; o++) {
      t.indexOf(i[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, i[o]) && (n[i[o]] = e[i[o]]);
    }
  }

  return n;
}

function extractAdditionalParams(e) {
  return e.reduce(function (e, t) {
    var n = e.events,
        i = e.additionalParams;
    return "index" in t ? {
      additionalParams: i,
      events: n.concat([t])
    } : {
      events: n,
      additionalParams: t
    };
  }, {
    events: [],
    additionalParams: void 0
  });
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var supportsCookies = function supportsCookies() {
  try {
    return Boolean(navigator.cookieEnabled);
  } catch (e) {
    return !1;
  }
},
    supportsSendBeacon = function supportsSendBeacon() {
  try {
    return Boolean(navigator.sendBeacon);
  } catch (e) {
    return !1;
  }
},
    supportsXMLHttpRequest = function supportsXMLHttpRequest() {
  try {
    return Boolean(XMLHttpRequest);
  } catch (e) {
    return !1;
  }
},
    isUndefined = function isUndefined(e) {
  return void 0 === e;
},
    isNumber = function isNumber(e) {
  return "number" == typeof e;
},
    isFunction = function isFunction(e) {
  return "function" == typeof e;
};

function makeSendEvents(e) {
  return function (t, n) {
    var i,
        o,
        r,
        s = this;

    if (!this._userHasOptedOut) {
      if (!(!isUndefined(this._apiKey) && !isUndefined(this._appId) || (null === (i = n) || void 0 === i ? void 0 : i.headers["X-Algolia-Application-Id"]) && (null === (o = n) || void 0 === o ? void 0 : o.headers["X-Algolia-API-Key"]))) throw new Error("Before calling any methods on the analytics, you first need to call the 'init' function with appId and apiKey parameters or provide custom credentials in additional parameters.");
      var a = t.map(function (e) {
        var t,
            n,
            i = e.filters,
            o = __rest(e, ["filters"]),
            r = Object.assign(Object.assign({}, o), {
          userToken: (n = null === (t = e) || void 0 === t ? void 0 : t.userToken, null !== n && void 0 !== n ? n : s._userToken)
        });

        return isUndefined(i) || (r.filters = i.map(encodeURIComponent)), r;
      });
      return sendRequest(e, this._appId, this._apiKey, this._ua, this._endpointOrigin, a, null === (r = n) || void 0 === r ? void 0 : r.headers);
    }
  };
}

function sendRequest(e, t, n, i, o, r, s) {
  void 0 === s && (s = {});
  var a = Object.assign({
    "X-Algolia-Application-Id": t,
    "X-Algolia-API-Key": n,
    "X-Algolia-Agent": encodeURIComponent(i.join("; "))
  }, s);
  return e(o + "/1/events?" + Object.keys(a).map(function (e) {
    return e + "=" + a[e];
  }).join("&"), {
    events: r
  });
}

var version = "2.4.0",
    DEFAULT_ALGOLIA_AGENTS = ["insights-js (" + version + ")", "insights-js-browser-cjs (" + version + ")"];

function addAlgoliaAgent(e) {
  -1 === this._ua.indexOf(e) && this._ua.push(e);
}

var createUUID = function createUUID() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (e) {
    var t = 16 * Math.random() | 0;
    return ("x" === e ? t : 3 & t | 8).toString(16);
  });
},
    COOKIE_KEY = "_ALGOLIA",
    MONTH = 2592e6,
    setCookie = function setCookie(e, t, n) {
  var i = new Date();
  i.setTime(i.getTime() + n);
  var o = "expires=" + i.toUTCString();
  document.cookie = e + "=" + t + ";" + o + ";path=/";
},
    getCookie = function getCookie(e) {
  for (var t = e + "=", n = document.cookie.split(";"), i = 0; i < n.length; i++) {
    for (var o = n[i]; " " === o.charAt(0);) {
      o = o.substring(1);
    }

    if (0 === o.indexOf(t)) return o.substring(t.length, o.length);
  }

  return "";
};

function setAnonymousUserToken() {
  if (supportsCookies()) {
    var e = getCookie(COOKIE_KEY);
    e && "" !== e && 0 === e.indexOf("anonymous-") ? this.setUserToken(e) : (this.setUserToken("anonymous-" + createUUID()), setCookie(COOKIE_KEY, this._userToken, this._cookieDuration));
  }
}

function setUserToken(e) {
  this._userToken = e, isFunction(this._onUserTokenChangeCallback) && this._onUserTokenChangeCallback(this._userToken);
}

function getUserToken(e, t) {
  return isFunction(t) && t(null, this._userToken), this._userToken;
}

function onUserTokenChange(e, t) {
  this._onUserTokenChangeCallback = e, t && t.immediate && isFunction(this._onUserTokenChangeCallback) && this._onUserTokenChangeCallback(this._userToken);
}

objectAssignPolyfill();
var SUPPORTED_REGIONS = ["de", "us"];

function init(e) {
  var t;
  if (void 0 === e && (e = {}), !isUndefined(e.region) && -1 === SUPPORTED_REGIONS.indexOf(e.region)) throw new Error("optional region is incorrect, please provide either one of: " + SUPPORTED_REGIONS.join(", ") + ".");
  if (!(isUndefined(e.cookieDuration) || isNumber(e.cookieDuration) && isFinite(e.cookieDuration) && Math.floor(e.cookieDuration) === e.cookieDuration)) throw new Error("optional cookieDuration is incorrect, expected an integer.");
  "development" === process.env.NODE_ENV && console.info("Since v2.0.4, search-insights no longer validates event payloads.\nYou can visit https://algolia.com/events/debugger instead."), setOptions(this, e, {
    _userHasOptedOut: !!e.userHasOptedOut,
    _region: e.region,
    _useCookie: (t = e.useCookie, null !== t && void 0 !== t && t),
    _cookieDuration: e.cookieDuration || 6 * MONTH
  }), this._endpointOrigin = e.region ? "https://insights." + e.region + ".algolia.io" : "https://insights.algolia.io", this._ua = [].concat(DEFAULT_ALGOLIA_AGENTS), e.userToken ? this.setUserToken(e.userToken) : this._userToken || this._userHasOptedOut || !this._useCookie || this.setAnonymousUserToken();
}

function setOptions(e, t, n) {
  var i = t.partial,
      o = __rest(t, ["partial"]);

  i || Object.assign(e, n), Object.assign(e, Object.keys(o).reduce(function (e, t) {
    var n;
    return Object.assign(Object.assign({}, e), ((n = {})["_" + t] = o[t], n));
  }, {}));
}

function getVersion(e) {
  isFunction(e) && e(this.version);
}

function addEventType(e, t) {
  return t.map(function (t) {
    return Object.assign({
      eventType: e
    }, t);
  });
}

function clickedObjectIDsAfterSearch() {
  for (var e = [], t = arguments.length; t--;) {
    e[t] = arguments[t];
  }

  var n = extractAdditionalParams(e),
      i = n.events,
      o = n.additionalParams;
  return this.sendEvents(addEventType("click", i), o);
}

function clickedObjectIDs() {
  for (var e = [], t = arguments.length; t--;) {
    e[t] = arguments[t];
  }

  var n = extractAdditionalParams(e),
      i = n.events,
      o = n.additionalParams;
  return this.sendEvents(addEventType("click", i), o);
}

function clickedFilters() {
  for (var e = [], t = arguments.length; t--;) {
    e[t] = arguments[t];
  }

  var n = extractAdditionalParams(e),
      i = n.events,
      o = n.additionalParams;
  return this.sendEvents(addEventType("click", i), o);
}

function convertedObjectIDsAfterSearch() {
  for (var e = [], t = arguments.length; t--;) {
    e[t] = arguments[t];
  }

  var n = extractAdditionalParams(e),
      i = n.events,
      o = n.additionalParams;
  return this.sendEvents(addEventType("conversion", i), o);
}

function convertedObjectIDs() {
  for (var e = [], t = arguments.length; t--;) {
    e[t] = arguments[t];
  }

  var n = extractAdditionalParams(e),
      i = n.events,
      o = n.additionalParams;
  return this.sendEvents(addEventType("conversion", i), o);
}

function convertedFilters() {
  for (var e = [], t = arguments.length; t--;) {
    e[t] = arguments[t];
  }

  var n = extractAdditionalParams(e),
      i = n.events,
      o = n.additionalParams;
  return this.sendEvents(addEventType("conversion", i), o);
}

function viewedObjectIDs() {
  for (var e = [], t = arguments.length; t--;) {
    e[t] = arguments[t];
  }

  var n = extractAdditionalParams(e),
      i = n.events,
      o = n.additionalParams;
  return this.sendEvents(addEventType("view", i), o);
}

function viewedFilters() {
  for (var e = [], t = arguments.length; t--;) {
    e[t] = arguments[t];
  }

  var n = extractAdditionalParams(e),
      i = n.events,
      o = n.additionalParams;
  return this.sendEvents(addEventType("view", i), o);
}

objectKeysPolyfill(), objectAssignPolyfill();

var AlgoliaAnalytics = function AlgoliaAnalytics(e) {
  var t = e.requestFn;
  this._endpointOrigin = "https://insights.algolia.io", this._userHasOptedOut = !1, this._useCookie = !1, this._cookieDuration = 6 * MONTH, this._ua = [], this.version = version, this.sendEvents = makeSendEvents(t).bind(this), this.init = init.bind(this), this.addAlgoliaAgent = addAlgoliaAgent.bind(this), this.setUserToken = setUserToken.bind(this), this.setAnonymousUserToken = setAnonymousUserToken.bind(this), this.getUserToken = getUserToken.bind(this), this.onUserTokenChange = onUserTokenChange.bind(this), this.clickedObjectIDsAfterSearch = clickedObjectIDsAfterSearch.bind(this), this.clickedObjectIDs = clickedObjectIDs.bind(this), this.clickedFilters = clickedFilters.bind(this), this.convertedObjectIDsAfterSearch = convertedObjectIDsAfterSearch.bind(this), this.convertedObjectIDs = convertedObjectIDs.bind(this), this.convertedFilters = convertedFilters.bind(this), this.viewedObjectIDs = viewedObjectIDs.bind(this), this.viewedFilters = viewedFilters.bind(this), this.getVersion = getVersion.bind(this);
};

function getFunctionalInterface(e) {
  return function (t) {
    for (var n = [], i = arguments.length - 1; i-- > 0;) {
      n[i] = arguments[i + 1];
    }

    t && isFunction(e[t]) ? e[t].apply(e, n) : console.warn("The method `" + t + "` doesn't exist.");
  };
}

var requestWithSendBeacon = function requestWithSendBeacon(e, t) {
  var n = JSON.stringify(t);
  if (!navigator.sendBeacon(e, n)) return requestWithXMLHttpRequest(e, t);
},
    requestWithXMLHttpRequest = function requestWithXMLHttpRequest(e, t) {
  var n = JSON.stringify(t),
      i = new XMLHttpRequest();
  i.open("POST", e), i.setRequestHeader("Content-Type", "application/json"), i.setRequestHeader("Content-Length", "" + n.length), i.send(n);
};

function getRequesterForBrowser() {
  if (supportsSendBeacon()) return requestWithSendBeacon;
  if (supportsXMLHttpRequest()) return requestWithXMLHttpRequest;
  throw new Error("Could not find a supported HTTP request client in this environment.");
}

function processQueue(e) {
  var t = e.AlgoliaAnalyticsObject;

  if (t) {
    var n = getFunctionalInterface(this),
        i = e[t];
    i.queue = i.queue || [];
    var o = i.queue;
    o.forEach(function (e) {
      var t = [].slice.call(e),
          i = t[0],
          o = t.slice(1);
      n.apply(void 0, [i].concat(o));
    }), o.push = function (e) {
      var t = [].slice.call(e),
          i = t[0],
          o = t.slice(1);
      n.apply(void 0, [i].concat(o));
    };
  }
}

function createInsightsClient(e) {
  var t = getFunctionalInterface(new AlgoliaAnalytics({
    requestFn: e
  }));

  if ("object" == typeof window && !window.AlgoliaAnalyticsObject) {
    var n;

    do {
      n = createUUID();
    } while (void 0 !== window[n]);

    window.AlgoliaAnalyticsObject = n, window[window.AlgoliaAnalyticsObject] = t;
  }

  return t.version = version, t;
}

var entryBrowserCjs = createInsightsClient(getRequesterForBrowser());
exports.AlgoliaAnalytics = AlgoliaAnalytics, exports.default = entryBrowserCjs, exports.getFunctionalInterface = getFunctionalInterface, exports.getRequesterForBrowser = getRequesterForBrowser, exports.processQueue = processQueue;